/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Role_Bound_LandlordInputs */

const cs_clients_role_bound_landlord = /** @type {(inputs: Clients_Role_Bound_LandlordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnictví: nájemní nabídky, které klient vlastní nebo pronajímá.`)
};

const en_clients_role_bound_landlord = /** @type {(inputs: Clients_Role_Bound_LandlordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership: rental listings this client owns or lets.`)
};

/**
* | output |
* | --- |
* | "Ownership: rental listings this client owns or lets." |
*
* @param {Clients_Role_Bound_LandlordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_role_bound_landlord = /** @type {((inputs?: Clients_Role_Bound_LandlordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Role_Bound_LandlordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_role_bound_landlord(inputs)
	return cs_clients_role_bound_landlord(inputs)
});